import React, { useState } from "react";
import PropTypes from "prop-types";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { useNavigate } from "react-router-dom";

const DetailsTable = ({
  isSubmit = false,
  headers,
  data = [],
  keyMapping,
  currentPage,
  handleViewButton = () => {},
  handleClicableRow = () => {},
  handleEditClick,
  POID,
  handleSave,
  editRowId,
  editedQuantity,
  allotData,
  updateIcon,
  toggleSerialDrawer=()=>{},
  fetchPoStockout=()=>{}
  
}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [quantities, setQuantities] = useState({});
  const token = localStorage.getItem("authToken");
  const sanitizedData = Array.isArray(data) ? data : [];
  const navigate = useNavigate();
  console.log("datadetails", allotData);
  
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((row) => row.phystockinsr_id));
    }
    setSelectAll(!selectAll);
  };

  const handleRowSelect = (rowId) => {
    let updatedSelectedRows;
    if (selectedRows.includes(rowId)) {
      updatedSelectedRows = selectedRows.filter((id) => id !== rowId);
    } else {
      updatedSelectedRows = [...selectedRows, rowId];
    }

    setSelectedRows(updatedSelectedRows);
    if (updatedSelectedRows.length === data.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const handleQuantityChange = (e, rowId) => {
    setQuantities({ ...quantities, [rowId]: e.target.value });
  };

  const handleSubmit = async () => {
    const payload = {
      po_id: allotData?.po_id,
      po_details_id: allotData.po_details_id,
      items: selectedRows.map((rowId) => {
        const selectedRow = sanitizedData.find(
          (row) => row.phystockinsr_id === rowId
        );
        console.log("selectedRow", selectedRow);

        return {
          phystockinsr_id: selectedRow?.phystockinsr_id,
          is_selected: 1, // Mark as selected
        };
      }),
    };

    try {
      const response = await axiosInstance.post(
        "postockoutdetail/allotserialitemtopo",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toggleSerialDrawer();
      fetchPoStockout();
      navigate(ROUTES_NAVIGATION.STOCKOUTDETAILS);
    } catch (error) {
      console.error("Error submitting order:", error);
    }
  };

  return (
    <>
      <div className="stocktablecontainer">
        <table className="custom-table">
          <thead>
            <tr>
              {isSubmit && (
                <th>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
              )}
              {headers?.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sanitizedData?.map((row, rowIndex) => {
              const rowId = row.phystockinsr_id;
              const totalPrice =
                row.purchase_price * (quantities[rowId] || 1) * 1.18;

              return (
                <tr key={rowId} onClick={() => handleClicableRow(row)}>
                  {isSubmit && (
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(rowId)}
                        onChange={() => handleRowSelect(rowId)}
                        onClick={(e) => e.stopPropagation()} // Prevent row click on checkbox click
                      />
                    </td>
                  )}
                  {headers?.map((header, colIndex) => {
                    const key = keyMapping[header];

                    if (header === "Action") {
                      return (
                        <td key={colIndex}>
                          {key.map((action, actionIndex) => (
                            <img
                              key={actionIndex}
                              src={
                                rowId === editRowId && action.type === "edit"
                                  ? updateIcon
                                  : action.icon
                              }
                              style={{ gap: 5, marginLeft: 10 }}
                              data-tip={action.label}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (
                                  action.type === "edit" &&
                                  rowId !== editRowId
                                ) {
                                  handleEditClick(row); // Enter edit mode for this row
                                } else if (updateIcon) {
                                  handleSave(row); // Save changes for this row
                                } else if (action.type === "view") {
                                  handleViewButton(row);
                                }
                              }}
                              className="action-icon"
                            />
                          ))}
                        </td>
                      );
                    }

                    if (
                      header === "Order Quantity" &&
                      isSubmit &&
                      selectedRows.includes(rowId)
                    ) {
                      return (
                        <td key={colIndex}>
                          <input
                            type="number"
                            value={quantities[rowId] || ""}
                            onChange={(e) => handleQuantityChange(e, rowId)}
                            style={{
                              width: "56px",
                              height: "28px",
                              padding: "4px",
                              fontSize: "14px",
                              fontWeight: "500",
                              borderRadius: "4px",
                              border: "2px solid #7BD755",
                              paddingLeft: "10px",
                            }}
                          />
                        </td>
                      );
                    }

                    if (header === "Total Price") {
                      return <td key={colIndex}>{totalPrice.toFixed(2)}</td>;
                    }

                    return <td key={colIndex}>{row[key]}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {isSubmit && (
        <div className="btncontainer mt-3">
          <button className="submit-btn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      )}
    </>
  );
};

DetailsTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  keyMapping: PropTypes.object.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleQuantityChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  editRowId: PropTypes.number,
  editedQuantity: PropTypes.object.isRequired,
};

DetailsTable.defaultProps = {
  itemsPerPage: 10,
  isAllocation: false,
};

export default DetailsTable;
